import { AUTH_USER_KEY } from '@/lib/constants/authentication'

const getCurrentUser = () => {
  const userItem = localStorage.getItem(AUTH_USER_KEY) || null

  if (!userItem) {
    return null
  }

  return JSON.parse(userItem)
}

export default getCurrentUser
